// Common Client V2 imports
const {
  ARTICLE_DOMAIN_BLOCKED,
  ARTICLE_MIXES_UPDATED,
  ARTICLES_REPORTED
} = require('client-v2/common/models/article/actions')
const {
  COLLECTION_FOLLOWING_CHANGE
} = require('client-v2/common/models/collection/actions')
const {
  USER_ADJUST_FOLLOWER_COUNT,
  USER_FOLLOWING_CHANGE
} = require('client-v2/common/models/user/actions')
// Container imports
const { defaultFeedActions } = require('./actions')
const { FeedStreamRecord } = require('./records')

module.exports = {
  createFeedReducer,
  // If you use the defaultReducer, you MUST also be using the default actions and record type
  defaultFeedReducer: createFeedReducer(defaultFeedActions, FeedStreamRecord)
}

// If you use a custom feedRecord type, make sure it quacks like the same duck.
function createFeedReducer(feedActions, feedRecordType) {
  return function feedReducer(state = new feedRecordType(), action) {
    const { type, payload } = action
    switch (type) {
      case feedActions.MORE_LOADING:
        return state.setNextPageLoading()
      case feedActions.MORE_LOADED:
        return state.appendNextPage(payload)
      case ARTICLE_DOMAIN_BLOCKED:
        return state.removeArticlesByHostname(payload.hostname)
      case ARTICLES_REPORTED:
        return state.removeArticlesByUrlIds(payload.urlIds)
      // Whitelist the actions that get passed to the items for performance reasons
      case USER_ADJUST_FOLLOWER_COUNT:
      case USER_FOLLOWING_CHANGE:
      case COLLECTION_FOLLOWING_CHANGE:
      case ARTICLE_MIXES_UPDATED:
        return state.itemsReducer(action)
      default:
        return state
    }
  }
}
